import React from 'react';
import injectSheet from 'react-jss';

// Components
import Head from 'next/head';

interface Props {
  buttonType: 'continue_with' | 'login_with';
}

export default function FacebookAuthButton({ buttonType }: Props) {
  return (
    <>
      <Head>
        <script
          defer
          data-crossorigin="anonymous"
          src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v5.0"
        ></script>
      </Head>
      <div id="fb-root" />
      <div
        className="fb-login-button"
        data-width=""
        data-size="large"
        data-button-type={buttonType}
        data-auto-logout-link="false"
        data-use-continue-as="false"
      />
    </>
  );
}
